import { koComponent } from '../../ko-utils';
import * as siteConfig from '../../site-config/config';
import { isFlagOn } from '../../utils/flags';

class PositionValue {
    constructor(params) {
        this.root = params.rootElement;
        this.onChange = params.onChange;
        this.positionBoxType = params.positionBoxType || 'target_element';
        this.allowDetached = params.allowDetached;

        /** @type {Array} */
        this.propsToInclude = ko.observable(ko.unwrap(params.propsToInclude || []));

        if (!this.root()) {
            this.root(new siteConfig.PositionValue());
        }

        if (this.onChange) {
            const subscribeAndNotify = (prop) => {
                if (this.root() && this.root()[prop]) {
                    this.root()[prop].subscribe((val) => {
                        this.onChange(prop);
                    });
                }
            };

            subscribeAndNotify('boundingIsTextContent');
            subscribeAndNotify('zIndex');
            subscribeAndNotify('xOffset');
            subscribeAndNotify('yOffset');
            subscribeAndNotify('position');
            subscribeAndNotify('width');
            subscribeAndNotify('minHeight');
            subscribeAndNotify('maxHeight');
            subscribeAndNotify('scrollMargin');
            subscribeAndNotify('arrowToTarget');
        }

        this.positionType = ko.computed(() => {
            if (!this.root().position() || this.root().position() == 'a' || (isFlagOn('pos_pop') && !this.root().position().startsWith('_det'))) return 'a';
            else if (this.root().position().startsWith('_det')) return '_det';

            return 'm';
        });

        this.positionSwitcher = isFlagOn('pos_pop') ?
            [{ text: 'Auto', val: 'a' }]
            :
            [
                { text: 'Auto', val: 'a' },
                { text: 'Manual', val: 'm' }
            ];

        if (this.allowDetached) {
            this.positionSwitcher.push({ text: 'Detached', val: '_det' });
        }

        this.onPositionSwitcherChanged = this.onPositionSwitcherChanged.bind(this);

        this.outsidePositionArrowClass = ko.computed(() => {
            return 'arrow-position-' + this.root().position();
        });

        this.setPositionOver = ko.observable();

        //this.outsidePositionHint = ko.computed(() => {
        //    const pos = this.setPositionOver() || this.root().position();

        //    switch (pos) {
        //        case 'otr': return 'Place the card top - right';
        //        case 'otl': return 'Place the card top - left';
        //        case 'ot': return 'Place the card top - center';

        //        case 'obr': return 'Place the card bottom - right';
        //        case 'obl': return 'Place the card bottom - left';
        //        case 'ob': return 'Place the card bottom - center';

        //        case 'orb': return 'Place the card right - bottom';
        //        case 'or': return 'Place the card right - center';
        //        case 'ort': return 'Place the card right - top';

        //        case 'olb': return 'Place the card left - bottom';
        //        case 'ol': return 'Place the card left - center';
        //        case 'olt': return 'Place the card left - top';
        //    };
        //});

        //console.log('INIT V', this.root().position());
    }

    isVisible(prop) {
        if (this.propsToInclude().length === 0) return true;

        return this.propsToInclude().indexOf(prop) !== -1;
    }

    setPosition(pos) {
        this.root().position(pos);
    }

    onPositionSwitcherChanged(item) {
        const selVal = ko.unwrap(item.val) || '';

        if (selVal != 'a' && !selVal.startsWith('_det')) {
            if (this.propsToInclude().indexOf('position_outside')) {
                this.root().position('obr');
            } else {
                this.root().position('lt');
            }
        } else if (selVal.startsWith('_det')) {
            this.root().position('_det-a');
        } else {
            this.root().position('a');
        }
    }
}

export default koComponent('position-value', PositionValue);